"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cutCatchAll = exports.copyCatchAll = exports.decodeTransferValue = exports.copyCurrentSelectionToClipboardAsPlainText = exports.cutWidgetsWithSelection = exports.cutWidget = exports.copyWidgetsWithSelection = exports.copyWidget = void 0;
var Serialise_1 = require("./../Tokenization/Serialise");
var EventTransfer_1 = require("../EventTransfer");
var TokenRenderer_1 = __importDefault(require("ContentTokens/TokenRenderer"));
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var GetFragment_1 = require("./GetFragment");
var CommonActions_1 = require("./CommonActions");
var isHandledCopy = function (result) { return result.handled; };
var copyWidget = function (event, editor) {
    var node = slate_react_1.ReactEditor.toSlateNode(editor, event.target);
    var path = slate_react_1.ReactEditor.findPath(editor, node);
    var voidEntry = slate_1.Editor.void(editor, { at: path });
    var _a = __read(voidEntry, 1), voidNode = _a[0];
    var cutTokens = (0, Serialise_1.serialise)([voidNode]);
    var transferHtml = (0, TokenRenderer_1.default)(cutTokens);
    (0, EventTransfer_1.setEventTransfer)(event.clipboardData, "html", transferHtml);
    var transferFragment = createTransferValue([voidNode]);
    (0, EventTransfer_1.setEventTransfer)(event.clipboardData, "fragment", transferFragment);
    return { handled: true, nodeEntry: voidEntry };
};
exports.copyWidget = copyWidget;
var copyWidgetsWithSelection = function (event, editor, selections) {
    var widgetEntries = selections
        .sort(function (a, b) { return slate_1.Path.compare(a.path, b.path); })
        .map(function (selection) { return slate_1.Editor.node(editor, selection.path); });
    if (!widgetEntries.every(function (widget) { return slate_1.Element.isElement(widget[0]); })) {
        return { handled: false };
    }
    var widgetNodes = widgetEntries.map(function (entry) { return entry[0]; });
    var cutTokens = (0, Serialise_1.serialise)(widgetNodes);
    var transferHtml = (0, TokenRenderer_1.default)(cutTokens);
    (0, EventTransfer_1.setEventTransfer)(event.clipboardData, "html", transferHtml);
    var transferFragment = createTransferValue(widgetNodes);
    (0, EventTransfer_1.setEventTransfer)(event.clipboardData, "fragment", transferFragment);
    return { handled: true, nodeEntries: widgetEntries };
};
exports.copyWidgetsWithSelection = copyWidgetsWithSelection;
var cutWidget = function (event, editor) {
    var copyResult = (0, exports.copyWidget)(event, editor);
    slate_1.Transforms.removeNodes(editor, { at: copyResult.nodeEntry[1] });
};
exports.cutWidget = cutWidget;
var cutWidgetsWithSelection = function (event, editor, selection) {
    var e_1, _a;
    var copyResult = (0, exports.copyWidgetsWithSelection)(event, editor, selection);
    if (!copyResult.handled) {
        return;
    }
    var reverseOrderedNodes = __spreadArray([], __read(copyResult.nodeEntries), false).sort(function (a, b) {
        return slate_1.Path.compare(b[1], a[1]);
    });
    try {
        for (var reverseOrderedNodes_1 = __values(reverseOrderedNodes), reverseOrderedNodes_1_1 = reverseOrderedNodes_1.next(); !reverseOrderedNodes_1_1.done; reverseOrderedNodes_1_1 = reverseOrderedNodes_1.next()) {
            var node = reverseOrderedNodes_1_1.value;
            slate_1.Transforms.removeNodes(editor, { at: node[1] });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (reverseOrderedNodes_1_1 && !reverseOrderedNodes_1_1.done && (_a = reverseOrderedNodes_1.return)) _a.call(reverseOrderedNodes_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
};
exports.cutWidgetsWithSelection = cutWidgetsWithSelection;
var copyCurrentSelectionToClipboardAsPlainText = function (event, editor) {
    var selection = editor.selection;
    if (!selection || slate_1.Range.isCollapsed(selection)) {
        return;
    }
    var selectedText = slate_1.Editor.string(editor, selection);
    (0, EventTransfer_1.setEventTransfer)(event.clipboardData, "text", selectedText);
};
exports.copyCurrentSelectionToClipboardAsPlainText = copyCurrentSelectionToClipboardAsPlainText;
var createTransferValue = function (fragment) {
    return window.btoa(encodeURIComponent(JSON.stringify(fragment)));
};
var decodeTransferValue = function (encodedFragment) {
    return JSON.parse(decodeURIComponent(window.atob(encodedFragment)));
};
exports.decodeTransferValue = decodeTransferValue;
function copyCatchAll(editor, event) {
    var fragment = (0, GetFragment_1.getFragment)(editor);
    var fragmentToTransfer = createTransferValue(fragment);
    (0, exports.copyCurrentSelectionToClipboardAsPlainText)(event, editor);
    (0, EventTransfer_1.setEventTransfer)(event.clipboardData, "fragment", fragmentToTransfer);
    try {
        var tokens = (0, Serialise_1.serialise)(fragment);
        (0, EventTransfer_1.setEventTransfer)(event.clipboardData, "html", (0, TokenRenderer_1.default)(tokens));
    }
    catch (_a) {
    }
    return true;
}
exports.copyCatchAll = copyCatchAll;
function cutCatchAll(editor, event) {
    var wasHandled = copyCatchAll(editor, event);
    if (!wasHandled)
        return;
    (0, CommonActions_1.deleteSelectedRange)(editor);
}
exports.cutCatchAll = cutCatchAll;
